export default {
  title: 'Order Invoices',
  list: {
    empty_list: {
      title: 'No Order Invoices yet.',
    },
    fields: {
      id: 'Id',
      total: 'Total',
      date: 'Date',
    },
  },
  export_modal: {
    title: 'Filter',
    start_date: {
      title: 'Start Date',
      placeholder: 'date',
    },
    end_date: {
      title: 'End Date',
      placeholder: 'date',
    },
    button: {
      title1: 'Apply',
      title2: 'Close',
    },
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
  },
};
